import React from 'react';
import './AboutDavid.css';

const AboutDavid = () => {
    const handleButtonClick = () => {
        window.location.href = 'https://closeracademy.es/';
      };

  return (
    <section className="about-david">
      <div className="text-content">
        <h2>¿QUIÉN ES <span className="highlight">DAVID GIRALDO?</span></h2>
        <p>
          Soy un joven apasionado por mi profesión y por formar a otras personas en este ámbito, ya que pude pasar de ser un
          barbero que se dejaba la piel por cobrar 100€ de comisión al final de mes por vender productos a ganar 100€ en una
          venta de 20 minutos.
        </p>
        <p>
          Es por ello que he decidido junto con un equipo de profesionales del sector crear una formación completa donde 
          cualquier persona pueda pasar a generar ingresos desde 0.
        </p>
        <p>
          Al principio, a mí también me costó dar el paso para cambiar y es normal que a ti también te vaya a ser incómodo, pero 
          una vez lo des, ya no querrás volver atrás.
        </p>
        <button className="cta-button"  onClick={handleButtonClick}>QUIERO SABER MÁS</button>
      </div>
      <div className="image-content">
        <img  src="/Images/david-foto.jpg" alt="David Giraldo" />
      </div>
    </section>
  );
};

export default AboutDavid;
